import { defineCustomElement } from 'vue';
import './assets/vfb-base-styling.scss';
import FormBuilder from './FormBuilder.vue';

type VueCustomElementConstructor = {
    new (): HTMLElement & {
        _applyStyles?: (styles?: string[], owner?: unknown) => void
        _def?: { nonce?: string }
        _root?: ParentNode & Node
        shadowRoot: ShadowRoot | null
        _styleChildren?: WeakSet<object>
        _styles?: HTMLStyleElement[]
    }
    prototype: HTMLElement & {
        _applyStyles?: (styles?: string[], owner?: unknown) => void
        _def?: { nonce?: string }
        _root?: ParentNode & Node
        shadowRoot: ShadowRoot | null
        _styleChildren?: WeakSet<object>
        _styles?: HTMLStyleElement[]
        __vfbLightDomStylePatched?: boolean
    }
}

function patchLightDomStyleInjection(element: VueCustomElementConstructor) {
    const prototype = element.prototype;

    if (prototype.__vfbLightDomStylePatched || !prototype._applyStyles) {
        return;
    }

    prototype._applyStyles = function(styles?: string[], owner?: object) {
        if (!styles?.length) {
            return;
        }

        if (owner) {
            if (owner === this._def || this._styleChildren?.has(owner)) {
                return;
            }

            this._styleChildren?.add(owner);
        }

        const target = this.shadowRoot ?? this._root ?? this;
        const nonce = this._def?.nonce;

        for (let i = styles.length - 1; i >= 0; i--) {
            const style = document.createElement('style');

            if (nonce) {
                style.setAttribute('nonce', nonce);
            }

            style.textContent = styles[i];
            target.prepend(style);

            (this._styles || (this._styles = [])).push(style);
        }
    };

    prototype.__vfbLightDomStylePatched = true;
}

if (typeof window !== 'undefined' && typeof customElements !== 'undefined') {
    if (!customElements.get('form-builder')) {
        const FormBuilderElement = defineCustomElement(FormBuilder, {
            shadowRoot: false,
        })
        patchLightDomStyleInjection(FormBuilderElement as VueCustomElementConstructor)
        customElements.define('form-builder', FormBuilderElement)
    }
}
